import { Link } from "react-router-dom";
import { useCategories } from "@/context/CategoriesContext";
import { paletteFor } from "@/lib/categories";
import { cn } from "@/lib/utils";

export default function CategoryBadge({ category, className, asLink = true }) {
  const { byName } = useCategories();
  const cat = byName(category);
  const meta = paletteFor(cat?.color);
  const slug = cat?.slug;

  const content = (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide",
        meta.badge,
        className,
      )}
      data-testid={`category-badge-${slug || "cat"}`}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", meta.solid)} />
      {category}
    </span>
  );

  if (!asLink || !slug) return content;

  return (
    <Link
      to={`/category/${slug}`}
      className="transition-opacity hover:opacity-80"
      onClick={(e) => e.stopPropagation()}
    >
      {content}
    </Link>
  );
}
